import React, { useEffect, useState } from 'react';
import './MobileVerification.scss';
import { http, AlertService, FxInput } from '../fx-core';
import { Button } from '@material-ui/core';

export const MobileVerification = (props) => {

    const [otp, setOtp] = useState("");

    const verifyMobile = () => {
        let apiOptions: any = {
            url: `user/verify/mobile`,
            data: {}
        };
        http.post(apiOptions);
    };

    const handleInputChange = (item) => {
        setOtp(item.value);
    };

    const handleClose = () => {
        props.closeDialog()
    };

    const verifyMobileStatus = () => {
        if (otp.trim().length <= 0) {
            AlertService.showErrorMsg("Please provide code");
            return;
        }
        let apiOptions: any = {
            url: `user/verify/mobile/status`,
            data: { otp }
        };
        http.post(apiOptions).then(res => {
            verifyMobileStatusCallBack(res);
        });
    };

    const verifyMobileStatusCallBack = (res) => {
        if (res && res.data) {
            onSuccessMobileVerify(res.data);
        }
    };

    const onSuccessMobileVerify = (res) => {
        if (res.isVerified) {
            props.handleVerification("success");
        }
        else {
            AlertService.showErrorMsg("Please provide valid code");
        }
    };

    useEffect(() => {
        verifyMobile();
    }, []);

    return (
        <div className="modalalign">
            <div className="row justify-content-between title-font px-3">
                <div className="py-1 pl-3">
                    <span>Mobile Verification</span>
                </div>
                <div className="text-right pointer my-auto">
                    <i className="fas fa-times-circle font-16 pr-3" onClick={handleClose}></i>
                </div>
            </div>
            <div className="col-12 mt-2 ml-2">
                <span>Please enter the code received in your mobile</span>
            </div>
            <div className="col-12 mt-2 ml-2">
                <FxInput name="otp" variant="outlined" label="Code" size="small"
                    value={otp}
                    onValueChange={handleInputChange}
                />
            </div>
            <div className="float-right mr-2 mb-2">
                <Button variant="contained" size="small" color="primary" onClick={verifyMobileStatus}>Verify</Button>
            </div>
        </div>
    );
};